const profiles = {
  SYSADMIN: 1,
  ADMIN: 2,
  GR: 4,
  RTV: 6
}

const isAdmin = ({ profileId }) => {
  return [profiles.SYSADMIN, profiles.ADMIN].includes(+profileId)
}

const isGR = ({ profileId }) => {
  return [profiles.GR].includes(+profileId)
}

const isRtv = ({ profileId }) => {
  return +profileId === profiles.RTV
}

export { profiles, isAdmin, isGR, isRtv }
